import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "noFunctionsFound" }
const _hoisted_2 = { class: "dropdown" }
const _hoisted_3 = { clas: "p-d-flex p-flex-column" }
const _hoisted_4 = { class: "p-m-0" }
const _hoisted_5 = {
  key: 0,
  class: "dropdown-icon-container"
}
const _hoisted_6 = {
  key: 0,
  class: "dropdown-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_component_DataTable, {
    id: "preview-datatable",
    first: _ctx.first,
    "onUpdate:first": _cache[1] || (_cache[1] = ($event: any) => (_ctx.first = $event)),
    value: _ctx.rows,
    lazy: true,
    paginator: _ctx.lazyParams.size > 15,
    rows: 15,
    totalRecords: _ctx.lazyParams.size,
    paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
    class: "p-datatable-sm kn-table kn-flex",
    filters: _ctx.filters,
    "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters = $event)),
    filterDisplay: "menu",
    currentPageReportTemplate: _ctx.$t('common.table.footer.paginated', { first: '{first}', last: '{last}', totalRecords: '{totalRecords}' }),
    stripedRows: "",
    responsiveLayout: "stack",
    breakpoint: "960px",
    onPage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onPage($event))),
    onSort: _ctx.onSort
  }, {
    empty: _withCtx(() => [
      _createVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
        return (_openBlock(), _createBlock(_component_Column, {
          class: "kn-truncated",
          style: _ctx.datasetPreviewTableDescriptor.columnStyle,
          field: col.field,
          key: col.field,
          sortable: _ctx.previewType === 'dataset' ? false : true
        }, {
          header: _withCtx(() => [
            _createVNode("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _createVNode("p", _hoisted_4, _toDisplayString(col.header), 1),
                _createVNode("small", null, _toDisplayString(col.type), 1)
              ]),
              (_ctx.previewType !== 'dataset')
                ? (_openBlock(), _createBlock("div", _hoisted_5, [
                    _createVNode("i", {
                      class: ["pi pi-filter-icon pi-filter p-ml-5", { 'filter-icon-active': _ctx.searchInput[col.field] }],
                      onClick: ($event: any) => (_ctx.searchVisible[col.field] = !_ctx.searchVisible[col.field])
                    }, null, 10, ["onClick"]),
                    (_ctx.searchVisible[col.field])
                      ? (_openBlock(), _createBlock("div", _hoisted_6, [
                          _createVNode(_component_InputText, {
                            modelValue: _ctx.searchInput[col.field],
                            "onUpdate:modelValue": ($event: any) => (_ctx.searchInput[col.field] = $event),
                            class: "p-inputtext-sm p-column-filter",
                            onInput: ($event: any) => (_ctx.onFilter(col))
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          body: _withCtx((slotProps) => [
            _withDirectives(_createVNode("span", null, [
              _createTextVNode(_toDisplayString(slotProps.data[col.field]), 1)
            ], 512), [
              [
                _directive_tooltip,
                slotProps.data[col.field],
                void 0,
                { top: true }
              ]
            ])
          ]),
          _: 2
        }, 1032, ["style", "field", "sortable"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["first", "value", "paginator", "totalRecords", "filters", "currentPageReportTemplate", "onSort"]))
}